angular.module("ainapp")
    .controller("OPBalncController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

            $scope.PageName = "Opening Balance";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                };
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.OBsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            VoucherNumber: {
                                type: "string",
                            },
                            SubAccounts: {
                                type: "string",
                            },

                            TotalDebit: {
                                type: "float",
                            },

                            TotalCredit: {
                                type: "float",
                            },

                            CalcGrandCreditTotal: {
                                type: "float",
                            },

                            CalcGrandDebitTotal: {
                                type: "float",
                            },
                            CreatedDate: {
                                type: "date",
                            },
                            "CreatedBy.UserName":{
                                type: "string",
                            }
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [



                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.date}}",
                                            },
                    {
                        field: "VoucherNumber",
                        title: "Voucher Number",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                        //                        template: "<div style='text-align: right'>#=kendo.toString(VoucherNumber, 'n')#</div>",

                                            },
                    {
                        field: "SubAccounts",
                        title: "Accounts",
                     },

                    {
                        field: "TotalDebit",
                        title: "Total Debit",
                        headerTemplate: "{{LanguageData.totaldebit}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalDebit, 'n')#</div>",

                                            },
                    {
                        field: "TotalCredit",
                        title: "Total Credit",
                        headerTemplate: "{{LanguageData.totalcredit}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalCredit, 'n')#</div>",
                                            },
                    {
                        field: "Currency.Name",
                        title: "Currency",
                        headerTemplate: "{{LanguageData.Currency}}",
                    },
                    {
                        field: "CalcGrandDebitTotal",
                        title: "Calc Total Debit",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandDebitTotal, 'n')#</div>",
                                            },
                    {
                        field: "CalcGrandCreditTotal",
                        title: "Calc Total Credit",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandCreditTotal, 'n')#</div>",
                                            },

                                            {
                                                field: "CreatedDate",
                                                template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                                                title: "Created Date"
                                            },
                        
                                            {
                                                field: "CreatedBy.UserName",
                                                title: "Created By"
                                            },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='Delete(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click=\"PrintInvoice(dataItem.Id, 'Opening Balance', dataItem.VoucherNumber)\"></button><button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button>  ",
                        width: '140px'
                        },


                                        ],
            };


            $scope.Edit = function (data) {
                $state.go("editOpeningBalance", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }

            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {

                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $('#deleteModal').modal('show');
                }
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteOpeningBalance($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.load = false;
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide')
                    } else {
                        toastr.warning(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            //            $scope.Print = function (data) {
            //                $scope.load = true;
            //                MainService.DeleteJV($scope.SelectedDataForDelete.Id).then(function (response) {
            //                    if (response) {
            //                        $scope.load = false;
            //                        toastr.success("Success");
            //                        $scope.refresh();
            //                    }
            //                }, function () {
            //                    toastr.error("NetworkError");
            //                    $scope.working = false;
            //                    $scope.load = false;
            //                })
            //
            //            }

            $scope.View = function (data) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToViewData);
                } else {
                    // $state.go("viewOpeningBalance", {
                    //     VoucherId: data.Id
                    // })

                    var url = $state.href('viewOpeningBalance', {
                        VoucherId: data.Id
                    });
                    window.open(url, '_blank');
                }
            }


                }])
